export const isAppTypeMpSklad = () => process.env['REACT_APP_MPSKLAD']?.toLowerCase() === 'true'

